export const retenciones = (state) => state.retenciones;
